/**
 * Admin Resource Authors API Service (T061 - US5)
 * HTTP client for resource authors CRUD endpoints
 */

import { apiClient } from '@/core/api/client';
import type {
  AdminResourceAuthorItem,
  CreateResourceAuthorPayload,
  UpdateResourceAuthorPayload,
} from '../types/admin-resource.type';

const BASE_PATH = '/admin/resource-authors';

type ListResponse = {
  data: AdminResourceAuthorItem[];
  total: number;
};

type ListParams = {
  search?: string;
};

export async function listResourceAuthors(
  params?: ListParams,
): Promise<AdminResourceAuthorItem[]> {
  const response = await apiClient.get<ListResponse>(BASE_PATH, { params });
  return response.data.data;
}

export async function createResourceAuthor(
  payload: CreateResourceAuthorPayload,
): Promise<AdminResourceAuthorItem> {
  const response = await apiClient.post<AdminResourceAuthorItem>(
    BASE_PATH,
    payload,
  );
  return response.data;
}

export async function updateResourceAuthor(
  id: string,
  payload: Omit<UpdateResourceAuthorPayload, 'id'>,
): Promise<AdminResourceAuthorItem> {
  const response = await apiClient.patch<AdminResourceAuthorItem>(
    `${BASE_PATH}/${id}`,
    payload,
  );
  return response.data;
}

export async function deleteResourceAuthor(id: string): Promise<void> {
  await apiClient.delete(`${BASE_PATH}/${id}`);
}

export const adminResourceAuthorsApi = {
  listResourceAuthors,
  createResourceAuthor,
  updateResourceAuthor,
  deleteResourceAuthor,
};
